// extracted by mini-css-extract-plugin
export default {"container":"ErrorBoundary_container__jo-mG","icon":"ErrorBoundary_icon__obfWP","header":"ErrorBoundary_header__Iwu59","text":"ErrorBoundary_text__fRiu+"};